<template>
  <div class="container">
        <div class="title">
          <!--标签-->
          <div>
            <div class="name">
              {{ testPaperTitleInfoVO.testPaperName }}
            </div>
          </div>
          <div class="text">
            <div>
              共{{ testPaperTitleInfoVO.testTotalNum }}道题 共{{
                testPaperTitleInfoVO.testTotalScore
              }}分
            </div>
          </div>
        </div>
        <div v-if="2=='1'">
          <v-btn
            class="my-0 mx-4"
            color="primary"
            @click="downloadFile"
            style="display: flex;
              width: 100px;
              height: 38px;
              background: #0171A3;
              border-radius: 5px;
              color: #FEFEFE;
              justify-content: center;
              align-items: center;
              margin: 0 0.5em 0 0;
              cursor: pointer;
              font-size: 14px;
              padding: 0 1em;
              float: right;"
          >
             <BBtnPrimary
              :clicked="doSave"
              btn-txt="保存"
              :disabled="String(disabledFlag)"
            />
          </v-btn>
        </div>
        <div
          v-for="(questionItem,
          testPagerReadIndex) in quetionList"
          :key="testPagerReadIndex"
          style="width: 70%; height:auto; margin: 10px"
        >
          <div style="margin-top: -10px; height:auto;">
            <div>
              <!--标签-->
              <div class="pa-0">
                <div
                  class="content"
                  style="
                    margin-top: 25px;
                    margin-left: 27px;
                    text-align: start;
                    font-weight: bold;
                  "
                >
                  {{ testPagerReadIndex + 1 }}.{{
                    questionItem.questionContent
                  }}
                  <span class="questionScore">
                    ({{ questionItem.questionScore }}分)
                  </span>
                </div>
              </div>

              <div class="file-box" >
                <div v-for="(item, index) in questionItem.itemVOList" :key="index" style="display: inline-block;">
                  <div v-if="item.fileType == '02'" style="width: 450px;display: inline-block; height:auto">
                    <!--标签-->
                    <!-- 视频 -->
                    <div v-if="item.fileType == '02'">
                      <img v-if="item.fileType == '02'"
                        class="delete-video"
                        src="@/assets/circle-delete.png"
                        v-on:click="deleteFile(questionItem.questionId,index)"
                        alt=""
                      />
                      <video v-if="item.fileType == '02'" class="video" :src="item.fileUrl" controls />
                    </div>
                  </div>
                </div>
              </div>

              <div class="file-box" >
                <div v-for="(item, index) in questionItem.itemVOList" :key="index" style="display: inline-block;">
                  <div v-if="item.fileType == '01'" style="display: inline-block; height:auto; width: 220px;">
                    <!-- 标签 -->
                    <!-- 图片 -->
                    <div v-if="item.fileType == '01'">
                      <img v-if="item.fileType == '01'"
                        class="delete-img"
                        src="@/assets/circle-delete.png"
                        v-on:click="deleteFile(questionItem.questionId,index)"
                        alt=""
                      />
                      <viewer>
                        <img
                          v-if="item.fileType =='01'"
                          :data-source="item.fileUrl"
                          :src="item.fileUrl? item.fileUrl:require('@/assets/avatar.jpg')"
                          class="image"
                        />
                      </viewer>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="box-btn">
              <!-- <div>
                <BBtnSecondary
                  class="wd-110"
                  :img-src="require('@/assets/new.png')"
                  :clicked="openUploadVideoPopup"
                  :hiddenKey="String(questionItem.questionId)"
                  btn-txt="上传视频"
                />
              </div> -->
              <div>
                <BBtnSecondary
                  class="wd-110"
                  :img-src="require('@/assets/new.png')"
                  :clicked="openUploadImgPopup"
                  :hiddenKey="String(questionItem.questionId)"
                  btn-txt="上传图片"
                />
              </div>
            </div>
            
          </div>
        </div>
        
        <!--按钮操作-->
        <div class="box box-btn">
          <BBtnPrimary
            :clicked="doSave"
            btn-txt="提交"
            :disabled="String(disabledFlag)"
          />
          <BBtnPrimary :clicked="doBack" btn-txt="返回"/>
        </div>
      </div>
</template>
<script>
import { practiceDetail, practiceSave } from "@/api/stuTestPaper";
import BBtnPrimary from "../../components2/BBtnPrimary";
import Hub from '../../events/Hub';
import UploadVideo from "../../views2/sample/UploadVideo";
import UploadImageNum from "../../views2/sample/UploadImageNum";
import BBtnSecondary from "../../components2/BBtnSecondary";
import PopupContents from "../../views2/sample/PopupContents";
import Vue from "vue";
export default {
  components: {
    BBtnPrimary,
    BBtnSecondary,
  },
  name: "StudentManagement",
  data: () => ({
    searchParam: {},
    snackbarText: "",
    id: 0,
    paperReadStudent: {}, //左侧学员信息
    quetionList: [],
    testPaperTitleInfoVO: {
      testPaperName: "",
      testTotalNum: 0,
      testTotalScore: 0,
      remarks: "",
      studentScore: 0,
    },
    questionId: 0,
    studentTestPaperId: null,
    releaseId: null,
    startTime: null,
    checkFlag: "",
    aleardyReturnFlag: false,
    reviewStatus: "",
    fileItemCount: [],
    disabledFlag: false,
  }),
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted () {
    this.$nextTick(
        function() {
            Hub.$on("modal-confirm", this.set);
        }.bind(this)
    );
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const params = {
        studentTestPaperId: vm.$route.params.studentTestPaperId,
        releaseId: vm.$route.params.releaseId,
        classId: vm.$route.params.classId,
      };

      // 参数赋值
      if (
        params.releaseId !== undefined &&
        params.releaseId !== null &&
        params.releaseId !== ""
      ) {
          // 把不为空的参数存入缓存
          vm.$store.commit("SET_STU_TEST_PAPER_PRACTICE_PARAMS", params);
      }

      // 参数赋值 发布试卷的id
      if (
        vm.$store.state.stuTestPagerPractice_releaseId !== undefined &&
        vm.$store.state.stuTestPagerPractice_releaseId !== null &&
        vm.$store.state.stuTestPagerPractice_releaseId !== ""
      ) {
        vm.releaseId =
          vm.$store.state.stuTestPagerPractice_releaseId;
        vm.studentTestPaperId =
          vm.$store.state.stuTestPagerPractice_studentTestPaperId;  
        vm.classId =
          vm.$store.state.stuTestPagerPractice_classId;  
      }
      vm.getTestPagerDetail();
    });
  },
  methods: {
    // 点击详情
    getTestPagerDetail() {
      this.fetchData();
    },
    async fetchData() {
      const params = {
        classId: this.classId,
        releaseId: this.releaseId,
        studentTestPaperId: this.studentTestPaperId,
      };
      const data = await practiceDetail(params);
      this.quetionList = data.data.questionVOList;
      this.startTime = data.data.startTime;
      console.log("****this.quetionList************",this.quetionList);
      this.testPaperTitleInfoVO = data.data.testPaperTitleInfoVO;
    },
    // 提交
    async doSave() {
      // 提交之后 按钮都禁用
      this.disabledFlag = true;

      var fileItemVOList = [];
      // 文件清单
      for (var k=0;k<this.quetionList.length;k++) {
        var itemVOList = this.quetionList[k].itemVOList
        for(var j=0;j<itemVOList.length;j++){
          fileItemVOList.push(itemVOList[j])
        }  
      }
      // 验证
      if (fileItemVOList.length==0) {
        Vue.prototype.$valertbar.show("所有题目都没有上传资料，不能提交！");
        // 返回之后 按钮不禁用
        this.disabledFlag = false;
        return 
      }
      var addParam = {}; 
      // 班級ID
      addParam.classId = this.classId;
      // 开始时间
      addParam.startTime = this.startTime;
      // 文件清单
      addParam.questionList = fileItemVOList;
      // 发布id
      addParam.releaseId = this.releaseId;
      console.log("******addParam*********:",addParam)
      const data = await practiceSave(addParam);
      console.log("******data*********:",data)
      if (data.code === 0) {
        Vue.prototype.$vsnackbar.show(data.msg);
        this.aleardyReturnFlag = false;
        // 返回之后 按钮不禁用
        this.disabledFlag = false;
        this.doBack()
      } else {
        this.snackbarText = data.msg;
        Vue.prototype.$valertbar.show(this.snackbarText);
        // 返回之后 按钮不禁用
        this.disabledFlag = false;
      }
    },
    // 上传图片
    openUploadImgPopup(questionId) {
      console.log("questionId =",questionId)
        Hub.$emit('open-modal');
        this.fileType = '01'
        this.questionId = questionId
        // 文件数
        var imgCount = 0;
        for (var k=0;k<this.quetionList.length;k++) {
          if(this.quetionList[k].questionId == questionId) {
            imgCount = this.quetionList[k].itemVOList.length
            break;
          } else {
            imgCount = 0
          }
        }
        console.log("imgCount",imgCount)
        var data = {
          imgCount: imgCount,
        };

        Hub.$emit('set-modal-data', data, '上传图片', UploadImageNum);
    },
    // 上传视频
    openUploadVideoPopup(questionId) {
        Hub.$emit('open-modal');
        this.fileType = '02'
        this.questionId = questionId
        Hub.$emit('set-modal-data', this.imgData, '上传视频', UploadVideo);
    },
    // 返回处理
    set(value) {
       console.log("value = ", value)
       var fileItemVOList = []
        // 上传图片
        if(this.fileType === '01') {
            if (value[0]) {
              for(var i=0;i<value.length;i++){
                var itemVo = {}
                itemVo.fileUrl = value[i]
                itemVo.fileType = '01'
                itemVo.questionId = this.questionId
                itemVo.imgLength = value.length
                fileItemVOList.push(itemVo)
              }
              this.aleardyReturnFlag = true;
            }
        }
        // 上传视频
        if(this.fileType === '02'){
          console.log("fileUrl = ", value.fileUrl)
          console.log("playTime = ", value.playTime)
            if (value.playTime) {
                var fileItemVo = {}
                fileItemVo.fileUrl = value.fileUrl
                fileItemVo.fileType = '02'
                fileItemVo.questionId = this.questionId
                fileItemVOList.push(fileItemVo)
                this.aleardyReturnFlag = true;
            }
        }

        for (var k=0;k<this.quetionList.length;k++) {
          if(this.quetionList[k].questionId == this.questionId){
            var itemVOList = this.quetionList[k].itemVOList
            for(var j=0;j<fileItemVOList.length;j++){
              itemVOList.push(fileItemVOList[j])
            }
            this.quetionList[k].itemVOList = itemVOList
            break
          }
        }

        // 确认返回
        if (value === 1) {
          this.aleardyReturnFlag = false;
            // 成功 页面刷新
            this.doBack()
        }
    },
    // 删除处理
    deleteFile(questionId, index) {

      for (var k=0;k<this.quetionList.length;k++) {
        if(this.quetionList[k].questionId == questionId){
          var itemVOList = this.quetionList[k].itemVOList
          Vue.delete(itemVOList,index)
          this.quetionList[k].itemVOList = itemVOList
          break
        }
      }
      this.aleardyReturnFlag = true;
    },
    // 返回处理
    doBack() {
       if (this.aleardyReturnFlag) {
          var message = "页面有未提交的数据，直接返回数据将丢失，是否继续？";
          Hub.$emit("open-modal");
          Hub.$emit("set-modal-data", message, "提示", PopupContents);
       } else {
        this.$router.push({
            name: "stu-homework-management",
        });
       }
    },
    destroyed() {
        Hub.$off("modal-confirm", this.set);
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  padding-top: 0px;
}
.bottom {
  padding-bottom: 0px;
}

.container {
  width: 100%;
  padding-top: 50px;
  align-items: center;
  flex-wrap: wrap;
}

.title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 65%;
}
.name {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 600;
  color: #333333;
}
.text {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}
.scoreContent {
  display: flex;
  flex-direction: row;
  margin-top: 50px;
  margin-bottom: 100px;
}
.score-text {
  margin-top: 7px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}
.score-value {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}
.inner-line {
  display: flex;
  flex-direction: row;
}
.box-right {
  margin-left: 20px;
  margin-top: 20px;
}
.toalScore-text {
  margin-top: 5px;
}
.score_class {
  border: none;
  width: 100px;
  height: 20px;
  justify-content: flex-end;
  margin-right: 20px;
  margin-top: 10px;
}
.content {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}
.questionScore {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #b3bbbe;
}
.score-content {
  display: flex; 
  font-size: 16px;
  justify-content: space-between;
}
.video {
  width: 440px;
  height: 270px;
  background: #000000;
}
.image {
  width: 200px;
  height: 220px;
  margin: 5px 10px 0px 0px;
}
.box-btn {
  display: flex;
  // flex-direction: row;
  justify-content: left;
  margin-left: 30px;
}
.file-box {
  // display: flex;
  // justify-content: flex-start;
  // max-height: 362px;
  // min-height: 0px;
  // margin: 10px 30px 20px 20px;
  // width: 100%;
  width: 100%;
  // overflow: auto;
  // overflow-x: hidden;
}
.inner-box {
  // display: flex;
  // flex-direction: row;
  flex-wrap: wrap;
  margin: 5px 10px 0px 0px;
  width: 440px;
  // float: left;
}
.delete-img {
  position: relative;
  width: 23px;
  height: 23px;
  left: 188px;
  top: 23px;
  cursor: pointer;
}
.delete-video {
  position: relative;
  width: 23px;
  height: 23px;
  left: 425px;
  top: 18px;
  z-index: 100;
  cursor: pointer;
}

</style>
